import React from "react";
import { Spinner } from "@themesberg/react-bootstrap";

function CustomDashboardLoader() {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "90vh",
      }}
    >
      <Spinner animation="border" />
    </div>
  );
}

export default CustomDashboardLoader;
